import React from 'react';
import {StyleSheet, View} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import {RouteProp, useRoute} from '@react-navigation/native';

import BackSubheader from 'src/components/elements/BackSubheader';
import Localized from 'src/constants/AppStrings';
import {ProductData} from 'src/types/serverTypes/Account';
import {ProductNutrition} from 'src/types/ProductType';
import {ProductImage} from './components/ProductImage';
import {NutritionSection} from './components/NutritionSection';
import {ProductInfo} from './components/ProductInfo';
import {Location} from '../../../types/serverTypes/Location';
import {DNA} from '../../../types/dnaTypes';

type RootStackParamList = {
  RecommendationsProductDetails: {
    product?: ProductData;
    nutrition?: ProductNutrition;
    location?: Location;
  };
};

type RecommendationsProductDetailsRouteProp = RouteProp<
  RootStackParamList,
  'RecommendationsProductDetails'
>;

const RecommendationsProductDetailsScreen = () => {
  const route = useRoute<RecommendationsProductDetailsRouteProp>();
  const {product, nutrition, location} = route.params || {};

  const dna: DNA = location?.locationFeatures?.dna as DNA;

  return (
    <BackSubheader title={Localized.Labels.product_details}>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <View style={styles.imageWrapper}>
          <ProductImage imageUrl={product.imageUrl} />
        </View>
        <ProductInfo name={product.productName} price={product.price} />
        {nutrition && nutrition.calories && dna.showCalories && (
          <NutritionSection product={product} nutrition={nutrition} />
        )}
      </ScrollView>
    </BackSubheader>
  );
};

const styles = StyleSheet.create({
  scrollContent: {
    flexGrow: 1,
    paddingLeft: 16,
    paddingRight: 16,
  },
  imageWrapper: {
    width: '100%',
    alignItems: 'center',
    marginTop: 20,
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
  },
});

export default RecommendationsProductDetailsScreen;
